import { stringify } from "qs";

import consumerApi from "api/services/consumer-api";
import { MenuItem } from "custom-types/MenuItem";
import { Strain } from "custom-types/Strain";
import logError from "utils/logError";

export type MatchingStrainResult = {
  strain: Strain;
  score: number;
  menuItems: MenuItem[];
};

type SimilarStrainsResponse = {
  data: MatchingStrainResult[];
};

export const getSimilarStrainMenuItems = async (
  menuItemId: number,
  productCategory = "Flower",
  count = 4,
): Promise<{
  strains: MatchingStrainResult[];
  menuItemMatches: MenuItem[];
}> => {
  const route = `/api/menu_items/v1/${menuItemId}/similar_flowers`;
  const query = stringify(
    {
      "filter[product_category]": productCategory,
    },
    {
      arrayFormat: "brackets",
      encodeValuesOnly: true,
    },
  );

  try {
    const { data } = await consumerApi.get(`${route}?${query}`);

    const { data: matches } = data as SimilarStrainsResponse;

    const menuItemMatches = matches
      .reduce<
        MenuItem[]
      >((menuItems, matches) => [...menuItems, ...matches.menuItems], [])
      .slice(0, count);

    return { menuItemMatches, strains: matches };
  } catch (e) {
    logError(e.message, {
      functionName: "getSimilarStrainMenuItems",
      service: "consumer",
      statusCode: e.statusCode,
    });

    return { menuItemMatches: [], strains: [] };
  }
};
